import React from 'react'

const encode = data => {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&')
};

export default class Form extends React.Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  handleSubmit = e => {
    e.preventDefault();
    fetch('/', {
      method: 'POST',
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({
        "form-name": 'swiss-contact-form',
        ...this.state
      })
    })
      .then(() => {
        this.setState({
          name: '',
          email: '',
          message: '',
          phone: '',
          bot: '',
        });
        alert('Success! Your message was successfully delivered!')
      })
      .catch(error => alert(error))
  };

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  render() {
    const {name, email, message, phone} = this.state;

    return (
      <form
        name="swiss-contact-form"
        method="post"
        action="/thanks/"
        data-netlify="true"
        data-netlify-honeypot="bot-field"
        onSubmit={this.handleSubmit}
        className="card"
      >
        <input type="hidden" name="swiss-contact-form" value="swiss-contact-form" />
        <input type="hidden" name="bot-field" onChange={this.handleChange} />
        <div className="form-group">
          <label htmlFor="name">Name</label>
          <input
            value={name}
            className="form-control"
            type="text"
            name="name"
            id="name"
            onChange={this.handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="contact-mail">EMAIL ADDRESS</label>
          <input
            value={email}
            className="form-control"
            type="email"
            name="email"
            id="email"
            onChange={this.handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="phone">PHONE NUMBER</label>
          <input
            value={phone}
            className="form-control"
            type="tel"
            name="phone"
            id="phone"
            onChange={this.handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="message">MESSAGE</label>
          <textarea
            value={message}
            className="form-control"
            name="message"
            id="message"
            onChange={this.handleChange}
            required
          />
        </div>
        <div className="text-center mt-50">
          <button type="submit" className="btn-main btn-alt">SEND MESSAGE</button>
        </div>
      </form>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Form.js